import { z } from 'zod'

export const DAY_PRESETS = [1, 3, 7, 14, 30] as const

export const shortTermSearchSchema = z.object({
  mode: z.enum(['stores', 'projects']).optional().default('stores'),
  storeIds: z.array(z.number().int().positive()).optional().default([]),
  referenceStoreIds: z.array(z.number().int().positive()).optional().default([]),
  projectIds: z.array(z.number().int().positive()).optional().default([]),
  days: z.number().int().min(1).max(31).optional().default(30),
  productIds: z.array(z.number().int().positive()).optional().default([]),
  tab: z.enum(['forecast', 'backtest']).optional().default('forecast'),
  asOf: z.string().optional(),
})

export type ShortTermSearch = z.infer<typeof shortTermSearchSchema>
